import React from "react";
import { formatReportHtml } from "../../../utils/formatReportHtml";

interface Props {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  report: any;
}

const StressDrawer: React.FC<Props> = ({
  open,
  onClose,
  loading,
  report,
}) => {
  return (
    <>
      {/* Overlay */}
      <div
        onClick={onClose}
        className={`fixed inset-0 bg-black/30 backdrop-blur-sm z-40 transition ${
          open ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
      />

      {/* Drawer */}
      <div
        className={`
          fixed
          right-0
          top-[64px]
          h-[calc(100vh-64px)]
          w-full
          sm:w-[420px]
          lg:w-[780px]
          bg-white
          shadow-2xl
          z-50
          transform transition-transform duration-500
          ${open ? "translate-x-0" : "translate-x-full"}
        `}
      >
        {/* Header */}
        <div className="flex justify-between items-center px-4 sm:px-6 py-4 border-b">

          <h2 className="text-base sm:text-lg lg:text-xl font-semibold text-[#26295e] truncate pr-4">
            {report?.title}
          </h2>

          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800 text-lg sm:text-xl"
          >
            ✕
          </button>

        </div>

        {/* Content */}
        <div className="h-full overflow-y-auto px-4 sm:px-6 lg:px-8 py-5 sm:py-6 pb-20 sm:pb-24 text-[#4b507d]">

          {loading && (
            <p className="text-sm sm:text-base">Loading report...</p>
          )}

          {!loading && report && (
            <div
              className="
                text-sm sm:text-base lg:text-[17px]
                leading-7 sm:leading-8
                text-[#4b507d]
              "
              dangerouslySetInnerHTML={{
                __html: formatReportHtml(report.details),
              }}
            />
          )}

        </div>
      </div>
    </>
  );
};

export default StressDrawer;